module.exports = __webpack_public_path__ + "img/ic_flow.4be12ac5.svg";